import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Tabs } from 'antd';
import PaymentSummaryUI from './PaymentSummaryUI';
import { pageSectionTitle } from '../util/Style';
import PaymentSummaryStore from '../stores/PaymentSummaryStore';

const { TabPane } = Tabs;

const tabBarStyle = {
    fontWeight: "bold",
}

class PaymentUI extends Component {

    constructor(props) {
        super(props);
        this.dailyStore = new PaymentSummaryStore({ apiProxy: props.appStore.apiProxy, collectionType: "daily" });
        this.monthlyStore = new PaymentSummaryStore({ apiProxy: props.appStore.apiProxy, collectionType: "monthly" });
        this.doctorwisedaily = new PaymentSummaryStore({ apiProxy: props.appStore.apiProxy, collectionType: "Doctorwisedaily" });
        this.doctorwisemonthly = new PaymentSummaryStore({ apiProxy: props.appStore.apiProxy, collectionType: "Doctorwisemonthly" });
    }

     getActiveTabKey = () => {
        const { currentComponent } = this.props.appStore;
        const tabMap = {daily: "1", monthly: "2",Doctorwisedaily: "3",Doctorwisemonthly: "4" };
        const collectionType = currentComponent?.params?.collectionType || "daily";
        return tabMap[collectionType] || "1";
    }

    handleTabChange = (key) => {
        const keyMap = { "1": "daily","2": "monthly","3": "Doctorwisedaily","4": "Doctorwisemonthly"};
        const collectionType = keyMap[key];
        this.props.appStore.currentComponent = {
            label: "Payments",
            key: "payments",
            params: { collectionType }
        };
    }

    render() {
        return (
            <Tabs activeKey={this.getActiveTabKey()} onChange={this.handleTabChange} style={{ paddingLeft: 10, paddingRight: 10 }} defaultActiveKey="1" tabBarStyle={tabBarStyle} tabBarExtraContent={pageSectionTitle("Payments")}>
                <TabPane tab="Daily" key="1">
                    <PaymentSummaryUI appStore={this.props.appStore} title="Daily" store={this.dailyStore} />
                </TabPane>
                <TabPane tab="Monthly" key="2">
                    <PaymentSummaryUI appStore={this.props.appStore} title="Monthly" store={this.monthlyStore} />
                </TabPane>
                <TabPane tab="Doctorwisedaily" key="3">
                    <PaymentSummaryUI appStore={this.props.appStore} title="Doctorwisedaily" store={this.doctorwisedaily} />
                </TabPane>
                <TabPane tab="Doctorwisemonthly" key="4">
                    <PaymentSummaryUI appStore={this.props.appStore} title="Doctorwisemonthly" store={this.doctorwisemonthly} />
                </TabPane>
            </Tabs>
        )
    }
}

export default observer(PaymentUI)
